import { FC } from 'react'

import { ISvgClass } from '../interface'

const CampaignIcon: FC<ISvgClass> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.0"
      width="24px"
      height="24px"
      viewBox="0 0 512.000000 512.000000"
      preserveAspectRatio="xMidYMid meet"
      {...props}
    >
      <g
        transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
        fill="inherit"
        stroke="none"
      >
        <path d="M3409 4506 c-126 -35 -252 -140 -306 -254 l-27 -58 -415 -168 c-229 -93 -603 -245 -831 -338 l-414 -168 -442 0 c-492 0 -528 -4 -657 -72 -81 -43 -202 -164 -245 -245 -62 -118 -72 -184 -72 -478 0 -144 5 -288 11 -321 5 -32 31 -101 56 -153 35 -74 59 -108 112 -160 114 -112 240 -166 413 -178 l98 -6 0 -416 c0 -229 5 -450 10 -491 17 -134 96 -258 210 -332 125 -80 297 -90 435 -24 134 63 228 185 254 330 7 37 11 215 11 458 0 219 3 398 8 398 4 0 337 -134 740 -298 l733 -298 29 -51 c67 -117 202 -210 339 -233 228 -38 463 108 532 331 18 58 19 115 19 1448 0 1518 3 1426 -57 1545 -32 64 -125 157 -189 189 -110 56 -247 72 -355 43z m218 -334 c67 -48 63 53 63 -1445 l0 -1354 -23 -34 c-12 -19 -43 -45 -69 -57 -62 -31 -111 -24 -166 24 -33 28 -43 45 -52 87 -7 36 -10 452 -8 1372 3 1311 3 1320 24 1355 34 58 79 82 145 78 36 -3 66 -12 86 -26z m-581 -2569 c-2 -2 -266 103 -587 233 -321 130 -642 261 -714 290 l-130 52 -2 539 -3 538 718 291 717 290 3 -1114 c1 -614 0 -1117 -2 -1119z m-1756 1111 l0 -485 -377 3 c-372 3 -379 3 -425 26 -67 33 -123 94 -148 160 -20 52 -21 72 -18 316 l3 261 27 52 c32 61 101 120 160 138 32 10 133 14 411 14 l367 1 0 -486z m0 -1239 c0 -347 -3 -442 -14 -468 -44 -105 -180 -116 -243 -20 -17 25 -18 63 -21 475 l-3 448 141 0 140 0 0 -435z" />
        <path d="M4687 3760 c-16 -5 -116 -59 -223 -121 -207 -120 -228 -139 -239 -214 -7 -48 24 -117 67 -148 42 -31 116 -34 169 -7 122 63 357 204 381 230 53 57 56 142 7 204 -37 47 -109 72 -162 56z" />
        <path d="M4484 2871 c-95 -58 -107 -180 -25 -254 51 -46 76 -49 336 -45 238 3 260 9 303 84 42 73 19 159 -58 212 -32 21 -40 22 -279 22 -225 0 -249 -2 -277 -19z" />
        <path d="M4313 2200 c-44 -22 -75 -64 -87 -113 -9 -40 11 -106 42 -137 40 -39 395 -240 436 -247 23 -4 53 1 81 11 100 39 133 171 62 250 -12 14 -109 75 -216 137 -218 125 -248 134 -318 99z" />
      </g>
    </svg>
  )
}

export default CampaignIcon
